import { useQuery } from '@apollo/client/react';
import { CelloReferralCodeDocument } from '@graphql/queries/cello/referral-code.graphql';
import { createChildLogger } from '@modules/logger';
import { useEffect } from 'react';

const logger = createChildLogger({ module: 'hooks/cello/use-cello-referrer' });

export interface CelloReferrer {
  firstName: string | null;
  imageUrl: string | null;
  isValid: boolean | null;
  loading: boolean;
}

export function useCelloReferrer(referralCode: string | null): CelloReferrer {
  const { data, loading, error } = useQuery(CelloReferralCodeDocument, {
    variables: { code: referralCode ?? '' },
    skip: !referralCode,
    context: { isUnauthenticatedRequest: true },
  });

  useEffect(() => {
    if (error) {
      logger.warn('Could not resolve the Cello referrer for the landing page', { error });
    }
  }, [error]);

  const payload = data?.celloReferralCode;

  return {
    firstName: payload?.referrerFirstName ?? null,
    imageUrl: payload?.referrerImageUrl ?? null,
    isValid: payload?.isValid ?? null,
    loading,
  };
}
